<div class="chip-selector" [class]="styleClass">
  <ng-container *ngFor="let chip of chipList">
    <basin-chip
      [label]="chip.label"
      [icon]="chip?.icon"
      [active]="checkIfSelected(chip)"
      [toggleType]="setToggleType(chip)"
      (click)="selectChip(chip)"
    ></basin-chip>
  </ng-container>
</div>
